import React from "react";

const Step = ({ number, done, title, detail, action }) => (
  <li className={`showcase-setup__step${done ? " is-done" : ""}`}>
    <span className="showcase-setup__dot" aria-hidden="true">
      {done ? (
        <svg viewBox="0 0 16 16" width="14" height="14">
          <path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        number
      )}
    </span>
    <div className="showcase-setup__step-text">
      <strong>{title}</strong>
      <span>{detail}</span>
    </div>
    <div className="showcase-setup__step-end">
      {done ? <span className="showcase-setup__state">Done</span> : action || <span className="showcase-setup__state is-wait">Not yet</span>}
    </div>
  </li>
);

export default Step;
